import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import {
  createFactoryItem,
  getAllFactoryItems,
  getDataForEdit,
  updateFactoryItem,
  deleteFactoryItem,
} from "../../store/Factory/FactoryApi";
import { headTitle } from "../../utility/GetTableListName";
import { factorySliceAction } from "../../store/Factory/FactorySlice";

import MainComponent from "../../components/Base/MainComponent";
//importing constant form option to create form input
import { FormOptionsFactory } from "../../ConstantData/FormOptions";
//importing inital form data to store value state
import { InitialFactoryFormData } from "../../ConstantData/InitialData";
//imporint form data error
import { ErrorFactoryFormData } from "../../ConstantData/ErrorOption";
function Factory() {
  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(getAllFactoryItems());
  }, []);
  const factoryList = useSelector((state) => state.factory.factoryList);
  const InitialFormDataStore = useSelector(
    (state) => state.factory.initialData
  );
  const factoryEditData = useSelector((state) => state.factory.dataEdit);
  const isSuccess = useSelector((state) => state.applevel.isSuccess);
  let factoryFormError = useSelector((state) => state.factory.errorData);
  let isError = useSelector((state) => state.factory.isError);
  factoryFormError = { ...ErrorFactoryFormData, ...factoryFormError };
  const headTitleLabel = headTitle(FormOptionsFactory, [
    "Factory Name",
    "Address",
    "Email",
    "Phone",
  ]); //array is filed that is included in list heading

  return (
    <MainComponent
      InitialFormData={{ ...InitialFactoryFormData }}
      //function coming from store
      getDataForEdit={getDataForEdit}
      delteFun={deleteFactoryItem}
      createFun={createFactoryItem} //create function coming from store
      updateFun={updateFactoryItem} //update function coming from store
      FormOptions={FormOptionsFactory}
      OptionName="Create Factory"
      OptionNameList="Factory"
      generalList={factoryList}
      headTitle={headTitleLabel}
      EditData={factoryEditData}
      isError={isError}
      ErrorData={factoryFormError}
      InitialFormDataStore={InitialFormDataStore}
      setErrorData={factorySliceAction.setErrorData}
      isNotDeleteBtn={false}
      isSuccess={isSuccess}
    />
  );
}

export default Factory;
